/** US state parsing — extracted verbatim from the legacy inline JS. */

export const STATE_MAP: Record<string, string> = {
  AL: "Alabama", AK: "Alaska", AZ: "Arizona", AR: "Arkansas", CA: "California",
  CO: "Colorado", CT: "Connecticut", DE: "Delaware", FL: "Florida", GA: "Georgia",
  HI: "Hawaii", ID: "Idaho", IL: "Illinois", IN: "Indiana", IA: "Iowa",
  KS: "Kansas", KY: "Kentucky", LA: "Louisiana", ME: "Maine", MD: "Maryland",
  MA: "Massachusetts", MI: "Michigan", MN: "Minnesota", MS: "Mississippi", MO: "Missouri",
  MT: "Montana", NE: "Nebraska", NV: "Nevada", NH: "New Hampshire", NJ: "New Jersey",
  NM: "New Mexico", NY: "New York", NC: "North Carolina", ND: "North Dakota", OH: "Ohio",
  OK: "Oklahoma", OR: "Oregon", PA: "Pennsylvania", RI: "Rhode Island", SC: "South Carolina",
  SD: "South Dakota", TN: "Tennessee", TX: "Texas", UT: "Utah", VT: "Vermont",
  VA: "Virginia", WA: "Washington", WV: "West Virginia", WI: "Wisconsin", WY: "Wyoming",
  DC: "Washington, D.C.",
};

export const CITY_STATE_MAP: Record<string, string> = {
  "san francisco": "CA", "sunnyvale": "CA", "palo alto": "CA", "mountain view": "CA",
  "menlo park": "CA", "los angeles": "CA", "santa clara": "CA", "san jose": "CA", "foster city": "CA",
  "emeryville": "CA", "hayward": "CA", "hawthorne": "CA", "redwood city": "CA", "south san francisco": "CA",
  "seattle": "WA", "redmond": "WA", "bellevue": "WA", "woodinville": "WA",
  "new york": "NY", "new york city": "NY", "nyc": "NY", "glen cove": "NY",
  "boston": "MA", "watertown": "MA",
  "chicago": "IL",
  "austin": "TX", "bastrop": "TX", "dallas": "TX", "houston": "TX", "starbase": "TX",
  "atlanta": "GA",
  "denver": "CO", "boulder": "CO",
  "arlington": "VA",
  "raleigh": "NC", "durham": "NC",
  "philadelphia": "PA",
  "detroit": "MI",
  "st. louis": "MO",
  "miami": "FL", "cape canaveral": "FL",
  "tulsa": "OK",
  "memphis": "TN",
  "baltimore": "MD",
  "indianapolis": "IN",
  "portland": "OR",
  "phoenix": "AZ",
  "las vegas": "NV",
  "salt lake city": "UT",
};

/** Parse a free-text location string into one or more US state codes
 * (or ["Remote"] when the posting is explicitly remote/anywhere). */
export function getJobStates(location: string | null | undefined): string[] {
  if (!location) return ["Remote"];
  const states = new Set<string>();
  const locLower = location.toLowerCase();

  if (locLower.includes("remote") || locLower.includes("anywhere") || locLower.includes("nationwide")) {
    states.add("Remote");
  }

  const stateMatches = location.match(/\b([A-Z]{2})\b/g);
  if (stateMatches) {
    for (const code of stateMatches) {
      if (STATE_MAP[code]) states.add(code);
    }
  }

  const usStateMatches = location.match(/\bUS-([A-Z]{2})\b/gi);
  if (usStateMatches) {
    for (const match of usStateMatches) {
      const code = match.split("-")[1].toUpperCase();
      if (STATE_MAP[code]) states.add(code);
    }
  }

  for (const [code, name] of Object.entries(STATE_MAP)) {
    const escaped = name.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
    if (new RegExp(`\\b${escaped}\\b`, "i").test(locLower)) states.add(code);
  }

  for (const [city, code] of Object.entries(CITY_STATE_MAP)) {
    const escaped = city.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
    if (new RegExp(`\\b${escaped}\\b`, "i").test(locLower)) states.add(code);
  }

  if (states.size === 0) {
    if (locLower.includes("united states") || locLower.includes("usa") || locLower.includes("hq")) {
      states.add("Remote");
    }
  }

  return Array.from(states);
}
